import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Arquitecto } from '../../../models/arquitecto.model';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-arquitecto",
    templateUrl: "./arquitecto.component.html",
    styleUrls: ["./arquitecto.component.css"],
    providers: [UserService, FormService]
})

export class ArquitectoComponent {

    @ViewChild('openModal') openModal: TemplateRef<any>;
    public rut_arq;
    public mail_arq;
    public invalidRut: Boolean;
    public arquitecto: Arquitecto;
    public rows = [];
    public actualRow;

    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = [];// = [];
    public selectedArq: number = null;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private _userService: UserService, private rutValidator: RutValidator,
        private dialog: MatDialog, private spinner: NgxSpinnerService) {
        this.rut_arq = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })

        this.mail_arq = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })


        if (!JSON.parse(localStorage.getItem("arquitectos"))) {
            localStorage.setItem("arquitectos", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("arquitectos"));
        }
        this.invalidRut = true;
        this.arquitecto = {
            rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
        };
    }

    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    
    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }

    private _filter(value: string): string[] {
        const filterValue = ('' + value).toLowerCase();
        return this.options.filter(option => ('' + option).toLowerCase().includes(filterValue));
    }

    get_arquitecto(rut) {

        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();

        this._userService.getArquitecto(rut).subscribe(

            response => {
                if (response.message) {
                    this.arquitecto.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                    //console.log("get arquitecto response message",id);
                } else {
                    //console.log("get arquitecto else",id);
                    this.arquitecto.rut = response.rut ? response.rut : '';
                    this.arquitecto.nombre = response.nombre ? response.nombre : '';
                    this.arquitecto.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.arquitecto.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.arquitecto.direccion = response.direccion ? response.direccion : '';
                    this.arquitecto.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.arquitecto.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.arquitecto.comuna = response.comuna ? response.comuna : '';
                    this.arquitecto.fono = response.fono ? response.fono : '';
                    this.arquitecto.fax = response.fax ? response.fax : '';
                    this.arquitecto.mail = response.mail ? response.mail : '';

                    this.arquitecto.patente = response.patente ? response.patente : '';
                    this.arquitecto.profesion = response.profesion ? response.profesion : '';
                    /*console.log("this.arquitecto.patente: " + this.arquitecto.patente + "response.patente: " + response.patente);
                    console.log("this.arquitecto.mail: " + this.arquitecto.mail)
                    console.log("this.arquitecto: " + this.arquitecto);*/

                    this.arquitecto.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )

    }

    cleanData() {
        this.arquitecto = {
            rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
        };
        this.rut_arq.reset()
    }



    update_arquitecto(rut, id) {
        this.get_arquitecto(rut);
        this.selectedArq = id;
    }


    saveArquitecto() {
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.arquitecto.rut == this.rows[x].rut) {
                this.delete_arquitecto(x);
            }
        }

        //elimina fila cuando la editan
        if (this.selectedArq != null) {
            this.delete_arquitecto(this.selectedArq);
            this.selectedArq = null;
        }

        this.spinner.show();
        //console.log("this.arquitecto.rut", this.arquitecto.rut);
        this._userService.saveArquitecto(this.arquitecto).subscribe(
            response => {
                this.spinner.hide();
                //console.log("save response", response)
                if (response.update || response.save) {
                    //console.log("this.arquitecto.rut", this.arquitecto.rut);


                    $("#arq_modal").modal("hide");
                    this.actualRow = localStorage.getItem("arquitectos");
                    this.rows = JSON.parse(this.actualRow);
                    //console.log("this.arquitecto.pantente", this.arquitecto.patente);
                    this.rows = this.rows.concat({
                        rut: this.arquitecto.rut,
                        nombre: this.arquitecto.nombre,
                        apellido_mat: this.arquitecto.apellido_mat,
                        apellido_pat: this.arquitecto.apellido_pat,
                        direccion: this.arquitecto.direccion,
                        direccion_num: this.arquitecto.direccion_num,
                        direccion_complemento: this.arquitecto.direccion_complemento,
                        comuna: this.arquitecto.comuna,
                        fono: this.arquitecto.fono,
                        fax: this.arquitecto.fax,
                        mail: this.arquitecto.mail,
                        patente: this.arquitecto.patente,
                        profesion: this.arquitecto.profesion


                    })
                    localStorage.setItem("arquitectos", JSON.stringify(this.rows));
                    this.arquitecto = {
                        rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
                        direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
                    };
                    this.rut_arq.reset()
                    this.dialog.closeAll();
                }
            },
            error => {
                this.spinner.hide();
                console.log(error)
            }
        )


    }


    delete_arquitecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("arquitectos", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('arquitectos'));
            }
        }
    }


    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}